import { Injectable } from '@angular/core';
import * as moment from 'moment';
import constantURL from '../../../../../shared/constantURL';
import { BaseLoggedInPostService } from '../../../../../shared/services/base-logged-in-post.service';

@Injectable({
  providedIn: 'root'
})

export class CreditCardReportService extends BaseLoggedInPostService {
  _path = constantURL.CreditCardRequest.fetchCreditCardReport;

  processResult(res: any) {
      res.result.map((object: any) => {
      // console.log(res);
      object.createdAt = moment(object.createdAt).format('MMMM Do YYYY, h:mm:ss a');
      object.expiry = moment(object.expiry).format('MMMM Do YYYY, h:mm:ss a');
      object.comments = `transfer from EasyKash ${moment(object.comments).format('LL')}`;

      return object;
    });

    return res;
  }
}

